var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-click=\" vm.showAnalytics = !vm.showAnalytics \" class=\"o-wrapper o-wrapper--fluid u-cursor-pointer u-pb0\"><div class=\"c-panel c-panel--paddless toggler u-mb0\"><div class=\"c-panel__header\"><div class=\"c-text\">{{ vm.atAGlanceTitle | translate }}<span gg-icon=\"icon-chevron-down\" ng-class=\"{'is-active': vm.showAnalytics}\" class=\"float-right c-header-dropdown__icon u-ml- caret\"></span></div></div></div></div><executive-dashboard-overview query=\"vm.query\" ng-show=\"vm.showAnalytics\"></executive-dashboard-overview><div ng-show=\"vm.showAnalytics\" class=\"o-wrapper o-wrapper--fluid u-pb0\"><executive-dashboard-details query=\"vm.query\" scope-name=\"engagement\" breakdown-series=\"vm.breakdownSeries.engagement\" non-metric-table-cols=\"vm.tableCols.engagement\"></executive-dashboard-details></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/games/executiveDashboard.jade
 ** module id = 838
 ** module chunks = 0
 **/